import { Price } from '@jusbrasil-web/shared-price'

import { BenefitsList } from '../benefits-list'
import { LawsuitTwoOfferPlanCard_OfferLockCardFragment } from './__generated__/lawsuit-two-offer-plan-card.graphql'
import styles from './lawsuit-two-offer-plan-card.module.scss'

export function LawsuitPlanBenefits({
  offerLockCard,
}: {
  offerLockCard: LawsuitTwoOfferPlanCard_OfferLockCardFragment
}) {
  return (
    <div className={styles['two-offer-lock-card-benefits']}>
      <BenefitsList offerLockCard={offerLockCard} />
    </div>
  )
}

export function LawsuitPlanPriceInfo({
  offer,
}: {
  offer: LawsuitTwoOfferPlanCard_OfferLockCardFragment['offer']
}) {
  const { priceTitle, priceText, frequency } = offer

  return (
    <Price align="center" size="md" className={styles['two-offer-lock-card-price']}>
      {priceTitle && <Price.Title>{priceTitle}</Price.Title>}
      <Price.Value>
        {priceText}
        {frequency && <Price.ValueFrequency>{frequency}</Price.ValueFrequency>}
      </Price.Value>
    </Price>
  )
}
